<template>
  <v-btn-toggle v-model="model" borderless group :rounded="rounded">
    <v-tooltip :disabled="!tooltip" bottom transition="none" color="black">
      <template v-slot:activator="{ on, tooltip }">
        <v-btn :value="true" class="ma-0" v-bind="tooltip" v-on="on" :disabled="disabled">
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "AxToggle",
  props: {
    icon: { type: String, required: true },
    tooltip: { type: String, required: true },
    value: { type: Boolean, default: false },
    rounded: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.model = this.value
  },
  watch: {
    "model": function() {
      this.$emit('clicked', this.model)
    }
  },
  data() {
    return {
      model: false
    }
  }
}
</script>